import {
  oidcCallbackPath as handshakeOidcCallbackPath,
  samlSpAcsPath as handshakeSpAcsPath,
  samlSpMetadataPath as handshakeSpMetadataPath,
} from "../../../../shared/ssoHandshakePaths";
import { scimV2Path } from "../../../lib/apiPaths";

// The UI advertises canonical app-origin routes; the backend separately keeps
// minting legacy routes where existing IdP registrations require them.
const SSO_HANDSHAKE_PREFIX = "/sso";

export function ssoRegistrationUrls(tenantOrigin: string, providerId: string) {
  return {
    metadataUrl: `${tenantOrigin}${handshakeSpMetadataPath(SSO_HANDSHAKE_PREFIX, providerId)}`,
    entityId: tenantOrigin,
    acsUrl: `${tenantOrigin}${handshakeSpAcsPath(SSO_HANDSHAKE_PREFIX, providerId)}`,
    oidcRedirectUri: `${tenantOrigin}${handshakeOidcCallbackPath(SSO_HANDSHAKE_PREFIX, providerId)}`,
  };
}

export function scimBaseUrl(tenantOrigin: string) {
  return `${tenantOrigin}${scimV2Path}`;
}
